import { format } from 'date-fns';
import { formatNumber } from 'utils/formats';

import operationTypes from 'constants/operationTypes';
import transactionTypes from 'constants/transactionTypes';
import transactionTypesRealNames from 'constants/transactionTypesRealNames';

type GetHistoryTransactionsProps = {
  partnerId: string;
  operations: any[];
  holdingClassNames: any;
};

export const getHistoryTransactions = ({
  partnerId,
  operations,
  holdingClassNames,
}: GetHistoryTransactionsProps) => {
  if (!partnerId) return null;

  const history = operations.reduce((acc, op) => {
    const allTransactions = op.transactions
      .filter((transaction: any) => transaction.partner === partnerId)
      .map((transaction: any) => ({
        name: transactionTypesRealNames?.[transaction?.transactionType],
        range: `${formatNumber(transaction?.shareFrom)}-${formatNumber(
          transaction?.shareTo
        )}`,
        class: holdingClassNames?.[transaction?.shareClass],
      }));

    if (allTransactions.length) {
      const typeCondition =
        op.operationType === operationTypes.SELL_PARTICIPATION ||
        op.operationType === operationTypes.HERITAGE ||
        op.operationType === operationTypes.DONATION ||
        op.operationType === operationTypes.ENDORSEMENT ||
        op.operationType === operationTypes.TRANSMISSION;

      if (typeCondition) {
        const sells = allTransactions.filter(
          (transaction: any) =>
            transaction.name ===
            transactionTypesRealNames[transactionTypes.SELL]
        );
        const buys = allTransactions.filter(
          (transaction: any) =>
            transaction.name === transactionTypesRealNames[transactionTypes.BUY]
        );
        if (sells.length) {
          const transactionType =
            op.operationType === operationTypes.SELL_PARTICIPATION
              ? transactionTypes.SELL
              : op.operationType;

          acc.push({
            id: op._id,
            type: transactionType,
            date: format(new Date(op.date), 'dd.MM.yyyy'),
            transactions: sells,
            comments: op?.comments || '',
          });
        }
        if (buys.length) {
          const transactionType =
            op.operationType === operationTypes.SELL_PARTICIPATION
              ? transactionTypes.BUY
              : op.operationType;
          acc.push({
            id: op._id,
            type: transactionType,
            date: format(new Date(op.date), 'dd.MM.yyyy'),
            transactions: buys,
            comments: op?.comments || '',
          });
        }
      } else {
        acc.push({
          id: op._id,
          type: op.operationType,
          date: format(new Date(op.date), 'dd.MM.yyyy'),
          transactions: allTransactions,
          comments: op?.comments || '',
        });
      }
    }
    return acc;
  }, []);

  return history;
};
